import { doGet } from "./BaseAPI";

export function getQuarantineList() {
  return doGet(`/quarantine/domain`);
}

export function getQuarantinedMessage(messageId) {
  return doGet(`/quarantine/domain/${messageId}`);
}
